// import type from 'postcss-pxtorem/lib/type'
import Cookies from 'js-cookie'
import requests from '../request'

// 'Contont-type': 'application/json'
// 'Contont-type': 'application/x-www-form-urlencoded'

const unitInfo = localStorage.getItem('unitInfo')
let unitId
if (unitInfo && unitInfo !== null) {
  unitId = JSON.parse(unitInfo).strGuid
}
const userId = localStorage.getItem('userId')
const ids = `userId=${userId}&unitId=${unitId}`

// 经纬度
export const geocoderAPI = (params) => {
  return requests({
    url: `/api/map/getAddress`,
    method: 'POST',
    data: params,
    headers: {
      'Contont-type': 'application/json;charset=utf-8'
    }
  })
}




// 后台管理(菜单管理)  列表 
export const baseMenuSelectTreeListAPI = (params) => {
  return requests({
    url: `/api/system/baseMenu/selectTreeList?${ids}`,
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(菜单管理)  上级菜单 
export const baseMenuSelectPageListAPI = (params) => {
  return requests({
    url: `/api/system/baseMenu/selectPageList?${ids}`,
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(菜单管理)  新建菜单 
export const baseMenuInsertAPI = (data) => {
  return requests({
    url: `/api/system/baseMenu/insert?${ids}`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(菜单管理)  编辑回显
export const baseMenuSelectOneAPI = (params) => {
  return requests({
    url: `/api/system/baseMenu/selectOne?${ids}`,
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(菜单管理)  编辑菜单 
export const baseMenuUpdateAPI = (data) => {
  return requests({
    url: `/api/system/baseMenu/update?${ids}`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(菜单管理)  删除(单个)
export const baseMenuDeleteAPI = (data) => {
  return requests({
    url: `/api/system/baseMenu/delete?${ids}`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(菜单管理)  删除(多选)
export const baseMenuDeleteBatchAPI = (data) => {
  return requests({
    url: `/api/system/baseMenu/deleteBatch?${ids}`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}









// 后台管理(单位管理)  列表 
export const baseUnitSelectListAPI = (params) => {
  return requests({
    url: `/api/system/baseUnit/selectList`,
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(单位管理) 新建
export const baseUnitInsertAPI = (data) => {
  return requests({
    url: `/api/system/baseUnit/insert?${ids}`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(单位管理) 编辑回显
export const baseUnitSelectOneAPI = (params) => {
  return requests({
    url: `/api/system/baseUnit/selectOne?${ids}`,
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(单位管理) 编辑
export const baseUnitUpdateAPI = (data) => {
  return requests({
    url: `/api/system/baseUnit/update?${ids}`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(单位管理) 删除(单个)
export const baseUnitDeleteAPI = (data) => {
  return requests({
    url: `/api/system/baseUnit/delete?${ids}`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(单位管理) 删除(多选)
export const baseUnitDeleteBatchAPI = (data) => {
  return requests({
    url: `/api/system/baseUnit/deleteBatch?${ids}`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}





// 后台管理(字典管理) 类别下拉菜单
export const baseDictionarySelectDictionaryTypeAPI = (params) => {
  return requests({
    url: `/api/system/baseDictionary/selectDictionaryType?${ids}`,
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(字典管理) 列表
export const baseDictionarySelectDictionaryListAPI = (params) => {
  return requests({
    url: `/api/system/baseDictionary/selectDictionaryList?${ids}`,
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(字典管理) 新增
export const baseDictionaryInsertDictionaryAPI = (data) => {
  return requests({
    url: `/api/system/baseDictionary/insertDictionary?${ids}`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(字典管理) 编辑回显
export const baseDictionarySelectDictionaryOneAPI = (params) => {
  return requests({
    url: `/api/system/baseDictionary/selectDictionaryOne?${ids}`,
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(字典管理) 编辑
export const baseDictionaryUpdateDictionaryAPI = (data) => {
  return requests({
    url: `/api/system/baseDictionary/updateDictionary?${ids}`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(字典管理) 删除(单个)
export const baseDictionaryDeleteDictionaryAPI = (data) => {
  return requests({
    url: `/api/system/baseDictionary/deleteDictionary?${ids}`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(字典管理) 删除(多选)
export const baseDictionaryDeleteDictionaryBatchAPI = (data) => {
  return requests({
    url: `/api/system/baseDictionary/deleteDictionaryBatch?${ids}`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}






// 后台管理(用户管理)  用户管理 部门下拉菜单
export const selectPageListAPI = (params) => {
  return requests({
    url: `/api/system/baseUnit/selectPageList`,
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 后台管理(用户管理)  用户管理列表
export const baseUserSelectListAPI = (params) => {
  return requests({
    url: '/api/system/baseUser/selectList',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(用户管理)  新增用户
export const baseUserInsertAPI = (data) => {
  return requests({
    url: '/api/system/baseUser/insert',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(用户管理)  编辑用户信息回显
export const baseUserSelectOneAPI = (params) => {
  return requests({
    url: `/api/system/baseUser/selectOne?${ids}`,
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(用户管理)  编辑用户
export const baseUserUpdateAPI = (data) => {
  return requests({
    url: `/api/system/baseUser/update?${ids}`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(用户管理)  删除用户
export const baseUserDeleteAPI = (data) => {
  return requests({
    url: `/api/system/baseUser/delete?${ids}`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(用户管理)  重置密码
export const baseUserResetAPI = (data) => {
  return requests({
    url: `/api/system/baseUser/password/reset?${ids}`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(用户管理)  查询用户角色
export const baseUserGetByStrUserGuidAPI = (params) => {
  return requests({
    url: `/api/system/baseUser/getByStrUserGuid?${ids}`,
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(用户管理)  查询所有角色
export const baseRoleSelectListAPI = (params) => {
  return requests({
    url: `/api/system/baseRole/selectList?${ids}`,
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(用户管理)  保存分配角色
export const insertRelRoleUserAPI = (data) => {
  return requests({
    url: `/api/system/baseUser/insertRelUserRole?${ids}`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 后台管理(用户管理)  获取部门
export const baseDepartmentSelectPageListAPI = (params) => {
  return requests({
    url: '/api/system/baseDepartment/selectPageList',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(用户管理)  获取部门
// export const selectDepartmentByTree = (params) => {
//   return requests({
//     // /system/baseUnit/selectUnitByTree
//     url: '/api/system/baseDepartment/selectDepartmentByTree',
//     method: 'GET',
//     params,
//     headers: {
//       'Contont-type': 'application/json'
//     }
//   })
// }
export const selectDepartmentByTree = (params) => {
  return requests({

    url: '/api/system/baseDepartment/selectDepartmentByTree',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}


// 后台管理(用户管理)  分配部门回显
export const selectRelUserDepartmentAPI = (params) => {
  return requests({
    url: '/api/system/baseDepartment/selectRelUserDepartment',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(用户管理)  保存分配部门
export const assignDepartmentAPI = (data) => {
  return requests({
    url: '/api/system/baseDepartment/assignDepartment',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}






// 后台管理(部门管理)  分页查询
export const baseDepartmentSelectListAPI = (params) => {
  return requests({
    url: '/api/system/baseDepartment/selectList',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(部门管理)  新增
export const baseDepartmentInsertAPI = (data) => {
  return requests({
    url: '/api/system/baseDepartment/insert',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(部门管理)  修改
export const baseDepartmentUpdateAPI = (data) => {
  return requests({
    url: '/api/system/baseDepartment/update',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(部门管理)  删除
export const baseDepartmentDeleteAPI = (data) => {
  return requests({
    url: '/api/system/baseDepartment/delete',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}





// 后台管理(角色管理)  分页查询
export const baseRoleSelectPageListAPI = (params) => {
  return requests({
    url: `/api/system/baseRole/selectPageList?${ids}`,
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(角色管理)  新增
export const baseRoleAddBaseRoleAPI = (data) => {
  return requests({
    url: `/api/system/baseRole/insert?${ids}`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(角色管理)  编辑回显
export const baseRoleSelectOneAPI = (params) => {
  return requests({
    url: `/api/system/baseRole/selectOne?${ids}`,
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(角色管理)  修改
export const baseRoleUpdateAPI = (data) => {
  return requests({
    url: `/api/system/baseRole/update?${ids}`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(角色管理)  删除
export const baseRoleDeleteAPI = (data) => {
  return requests({
    url: `/api/system/baseRole/delete?${ids}`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(角色管理)  获取当前角色勾选的菜单
export const baseRoleSelectAllRoleMenuAuthorityAPI = (params) => {
  return requests({
    url: `/api/system/baseRole/selectAllRoleMenuAuthority?${ids}`,
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(角色管理)  获取全部菜单
export const baseRoleSelectTreeListAPI = (params) => {
  return requests({
    url: `/api/system/baseMenu/selectTreeList?${ids}`,
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(角色管理)  获取全部操作权限
export const baseAuthoritySelectListAPI = (params) => {
  return requests({
    url: `/api/system/baseAuthority/selectList?${ids}`,
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(角色管理)  保存菜单权限
export const baseRoleInsertRelRoleMenuAuthorityAPI = (data) => {
  return requests({
    url: `/api/system/baseRole/insertRelRoleMenuAuthority?${ids}`,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}



// 后台管理(模型管理)  查询模型列表
export const manageListWorkModelAPI = (data) => {
  return requests({
    url: '/api/model/manage/listWorkModel?key=' + data.key + '&name=' + data.name + '&pageNum=' + data.pageNum + '&pageSize=' + data.pageSize,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 后台管理(模型管理)  新建模型
export const manageAddWorkModelAPI = (data) => {
  return requests({
    url: '/api/model/manage/addWorkModel?key=' + data.key + '&name=' + data.name + '&category=' + data.category + '&description=' + data.description,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(模型管理)  删除
export const manageRemoveWorkModelAPI = (data) => {
  return requests({
    url: '/api/model/manage/removeWorkModel?modelId=' + data.modelId,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(模型管理)  发布流程
export const manageDeploymentWorkModelAPI = (data) => {
  return requests({
    url: '/api/model/manage/deploymentWorkModel?modelId=' + data.modelId,
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理(模型管理)  导出
export const manageExportAPI = (params) => {
  return requests({
    url: '/api/model/manage/export/${params.modelId}',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}




// 后台管理(日志管理)  列表
export const logSelectPageListAPI = (params) => {
  return requests({
    url: '/api/system/log/selectPageList',
    // + '&strCreateUserName=' + objData.strCreateUserName + '&startTime=' + objData.startTime + '&endTime=' + objData.endTime
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}





// 后台管理  事件管理列表
export const eventMPageAPI = (params) => {
  return requests({
    url: '/api/base/event/page',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 后台管理  隐患 危险源列表
export const dangerHiddenPageAPI = (params) => {
  return requests({
    url: '/api/information/page',
    method: 'post',
    data: params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 后台管理  上报隐患危险源(提交)
export const addInformation = (data) => {
  return requests({
    url: '/api/information/add',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 后台管理  删除隐患危险源(提交)
export const delInformation = (params) => {
  return requests({
    url: '/api/information/delete',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

//更新危险源隐患状态
export const updateInformationAPI = (data) => {
  return requests({
    url: '/api/information/update',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
//分页查询排版值班
export const schedulingPagelistAPI = (data) => {
  return requests({
    url: '/api/scheduling/pagelist',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
//新增排版值班
export const orgDutyAdd = (data) => {
  return requests({
    url: '/api/scheduling/add',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
//新增排版值班
export const orgDutyUpdateAPI = (data) => {
  return requests({
    url: '/api/scheduling/update',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
//删除排版值班
export const schedulingDeleteAPI = (data) => {
  return requests({
    url: '/api/scheduling/delete',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// //导出事件报告
export const eventResourceWord = (eventId) => {
  let link = document.createElement("a"); //创建一个a标签dom节点
  // link.download = fileName; //下载文件的名字
  link.href = `/api/export/eventResourceWord?eventId=${eventId}`; //下载文件的地址
  link.style.display = "none";//a标签默默无闻
  document.body.appendChild(link);//将a标签加入到dom中
  link.click();//添加点击事件进行文件下载
  // 下载完成可以退场
  URL.revokeObjectURL(link.href);//销毁下载地址
  document.body.removeChild(link);//将a标签从dom中移除
  // window.open(`/api/export/eventResourceWord?eventId=${eventId}`)
}

// 后台管理  标签列表
export const getLabelListByPageAPI = (params) => {
  return requests({
    url: '/api/label/getLabelListByPage',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 标签管理  新增标签
export const getLabelAddAPI = (data) => {
  return requests({
    url: '/api/label/add',
    method: 'post',
    data,
    headers: {
      token: Cookies.get("tokenAdmin"),
      'Contont-type': 'application/json',
    }
  })
}
// 标签管理  删除标签
export const getLabelDelectAPI = (data) => {
  return requests({
    url: `/api/label/removeById?ids=${data}`,
    method: 'post',
    data: {},
    headers: {
      token: Cookies.get("tokenAdmin"),
      'Contont-type': 'application/json',
    }
  })
}
// 标签管理  修改标签
export const getLabelUpdataAPI = (data) => {
  return requests({
    url: `/api/label/modifyById`,
    method: 'post',
    data,
    headers: {
      token: Cookies.get("tokenAdmin"),
      'Contont-type': 'application/json',
    }
  })
}

// 后台管理  日常工作列表
export const workRecordPageAPI = (data) => {
  return requests({
    url: '/api/workRecord/page',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 后台管理  日常工作新增
export const workRecordAddAPI = (data) => {
  return requests({
    url: '/api/workRecord/add',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理  巡检列表 分页查询
export const dailycheckGetListAPI = (data) => {
  data = {
    ...data,
    code: JSON.parse(localStorage.getItem('unitInfo')).strCode,
    strUserGuid: localStorage.getItem('userId'),
    userRoleList: JSON.parse(localStorage.getItem('userRoleLists'))
  }
  return requests({
    // url: '/api/dailycheck/pagelist',
    url: '/api/dailycheck/page/inspection',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理  巡检列表 分页查询
export const dailycheckGetDeatileAPI = (params) => {
  return requests({
    url: '/api/information/get',
    method: 'get',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}





// 后台管理  文件管理 标签下拉选
export const getLabelListAPI = (params) => {
  return requests({
    url: '/api/label/getLabelList',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理  文件管理列表
export const getFileListByPageAPI = (params) => {
  return requests({
    url: '/api/fileManager/getFileListByPage',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理  文件管理列表 上传
export const uploadFileListAPI = (data) => {
  return requests({
    url: '/api/fileManager/upload',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/x-www-form-urlencoded'
    }
  })
}

// 后台管理  文件管理列表 删除
export const deleteFileListAPI = (params) => {
  return requests({
    url: '/api/fileManager/delete',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理  文件管理列表 删除(批量)
export const exportZipAPI = (data) => {
  return requests({
    url: '/api/export/exportZip',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理   同步组织数据
export const selectAllOrganizationByTreeAPI = (params) => {
  return requests({
    url: '/api/system/baseUnit/selectUnitByTree',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理  资源分类 查询根节点列表
export const getRootResourceIndexAPI = (params) => {
  return requests({
    url: '/api/resourceNew/getRootResourceIndex',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理  资源分类 查询根节点列表(子)
export const getResourceIndexAPI = (params) => {
  return requests({
    url: '/api/resourceNew/getResourceIndex',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理  资源分类 新增节点
export const addIndexAPI = (data) => {
  return requests({
    url: '/api/resourceNew/addIndex',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理  资源分类 修改节点
export const updateIndexAPI = (data) => {
  return requests({
    url: '/api/resourceNew/updateIndex',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理  资源分类 修改节点
export const deleteIndexAPI = (data) => {
  return requests({
    url: '/api/resourceNew/deleteIndex',
    method: 'get',
    params: data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 后台管理  资源分类 树节点点击列表展示  新增资源分页接口
export const getIndexResourceNewAPI = (data) => {
  return requests({
    url: '/api/resourceNew/getIndexResourceNew',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理  资源分类 资源详情接口
export const getByIdResourceNewAPI = (data) => {
  return requests({
    url: '/api/resourceNew/getByIdResourceNew',
    method: 'get',
    params: data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理  资源分类 获取资源属性列表接口
export const getResourceFieldAPI = (data) => {
  return requests({
    url: '/api/resourceNew/getResourceField',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理  资源分类 新增资源接口
export const addResourceNewAPI = (data) => {
  return requests({
    url: '/api/resourceNew/addResourceNew',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理  资源分类 修改资源接口
export const updateResourceNewAPI = (data) => {
  return requests({
    url: '/api/resourceNew/updateResourceNew',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理  资源分类 删除资源接口
export const deleteResourceNewAPI = (data) => {
  return requests({
    url: '/api/resourceNew/deleteResourceNew',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 后台管理  资源分类 树节点Id选择
export const indexListAPI = (params) => {
  return requests({
    url: '/api/resourceNew/indexList',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 后台管理  资源分类 树节点Id选择
export const getConfigAPI = (params) => {
  return requests({
    url: '/api/config/getConfig?key=index_field',
    method: 'GET',
    params,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 资源动态列表查询	
export const resourceFieldList = (data) => {
  return requests({
    url: '/api/resourceField/list',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

// 资源动态新增	
export const resourceFieldInsert = (data) => {
  return requests({
    url: '/api/resourceField/insert',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 资源动态修改	
export const resourceFieldUpdate = (data) => {
  return requests({
    url: '/api/resourceField/update',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
// 资源动态删除		
export const resourceFieldDelete = (data) => {
  return requests({
    url: '/api/resourceField/delete',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

//新增事件配置 页面 字典项 
export const dictionaryAddAPI = (data) => {
  return requests({
    url: '/api/dictionary/add',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}

//编辑事件配置 页面 字典项 
export const dictionaryUpdateAPI = (data) => {
  return requests({
    url: '/api/dictionary/update',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
//查询事件配置 页面 字典项 
export const dictionaryGetListAPI = (data) => {
  return requests({
    url: '/api/dictionary/pagelist',
    method: 'POST',
    data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
//删除事件配置 页面 字典项 
export const dictionaryDlectAPI = (data) => {
  return requests({
    url: '/api/dictionary/delete',
    method: 'get',
    params: data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
//批量删除事件配置 页面 字典项 
export const dictionaryDlectsAPI = (data) => {
  return requests({
    url: '/api/dictionary/deletes',
    method: 'get',
    params: data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}
//查询字典项 类型 事件配置 页面 字典项 
export const dictionaryGroupAPI = (data) => {
  return requests({
    url: '/api/dictionary/group',
    method: 'get',
    params: data,
    headers: {
      'Contont-type': 'application/json'
    }
  })
}